module.exports = "https://static.wmbcdn.com/uniweb/images/44ad44829065d7d70eefe6b788f4b2ff.svg";